import {
  Card,
  CardContent,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

const MetricCard = ({ title, value, subtext, trend, icon: Icon }) => {
  const isTrendUp = trend && trend > 0;

  return (
    <Card>
      <CardContent>
        <Stack spacing={1}>
          <Typography
            color="textSecondary"
            gutterBottom
            variant="caption"
          >
            {title}
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
          >
            <Typography variant="h6">{value}</Typography>
            {Icon && <Icon fontSize="small" />}
          </Stack>
          {subtext && (
            <Typography
              variant="caption"
              color="textSecondary"
            >
              {subtext}
            </Typography>
          )}
          {trend !== undefined && (
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
            >
              {isTrendUp ? (
                <TrendingUpIcon
                  fontSize="small"
                  sx={{ color: "success.main" }}
                />
              ) : (
                <TrendingDownIcon
                  fontSize="small"
                  sx={{ color: "error.main" }}
                />
              )}
              <Typography
                variant="caption"
                sx={{
                  color: isTrendUp ? "success.main" : "error.main",
                }}
              >
                {Math.abs(trend)}% vs last period
              </Typography>
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

const OrderMetricsCards = ({ data, isLoading, error }) => {
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (isLoading || !data) {
    return (
      <Grid
        container
        spacing={2}
      >
        {[1, 2, 3, 4].map((i) => (
          <Grid
            key={i}
            size={{ xs: 12, sm: 6, md: 3 }}
          >
            <Skeleton
              variant="rectangular"
              height={120}
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <MetricCard
          title="Total Orders"
          value={data.totalOrders || 0}
          trend={data.ordersTrend}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <MetricCard
          title="Total Order Value"
          value={`$${(data.totalOrderValue || 0).toLocaleString("en-CA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`}
          trend={data.valueTrend}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <MetricCard
          title="Average Order Value"
          value={`$${(data.avgOrderValue || 0).toLocaleString("en-CA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <MetricCard
          title="Orders Per Rep (avg)"
          value={(data.ordersPerRepAvg || 0).toFixed(1)}
        />
      </Grid>
    </Grid>
  );
};

export default OrderMetricsCards;
